import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import type { Props as Options } from 'atoms/markdown/Markdown';
// only place where Markdown can be imported
// eslint-disable-next-line no-restricted-imports
import { Markdown } from 'atoms/markdown/Markdown';

export type Props = Options;

export const Content = (props: Props) => {
  const { hash } = useLocation();

  useEffect(() => {
    // if a hash link, find it
    if (hash) {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView(true);
        }
      }, 0);
    }
  }, [hash]); // do this on route change
  return <Markdown {...props} />;
};
